import { render, staticRenderFns } from "./FullviewReports.vue?vue&type=template&id=6ff9533c&scoped=true"
import script from "./FullviewReports.vue?vue&type=script&lang=ts"
export * from "./FullviewReports.vue?vue&type=script&lang=ts"
import style0 from "./FullviewReports.vue?vue&type=style&index=0&id=6ff9533c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff9533c",
  null
  
)

export default component.exports